import { supabase } from './supabaseClient';
import { compressImage } from './travelImages';

export const MAX_EVENT_IMAGE_SIZE = 8 * 1024 * 1024;

const BUCKET = 'travel-images';

export const uploadEventImage = async (userId, file) => {
  const image = await compressImage(file, 1600, 0.82);
  const path = `${userId}/events/${Date.now()}.jpg`;
  const { error } = await supabase.storage
    .from(BUCKET)
    .upload(path, image, { contentType: 'image/jpeg' });

  if (error) throw error;

  const { data: { publicUrl } } = supabase.storage.from(BUCKET).getPublicUrl(path);
  return publicUrl;
};

const getStoragePath = (url) => {
  const marker = `/object/public/${BUCKET}/`;
  const index = url?.indexOf(marker) ?? -1;
  return index === -1 ? null : decodeURIComponent(url.slice(index + marker.length).split('?')[0]);
};

export const deleteEventImage = async (url) => {
  const path = getStoragePath(url);
  if (!path) return;
  const { error } = await supabase.storage.from(BUCKET).remove([path]);
  if (error) console.error('刪除活動封面失敗:', error);
};
